import React, { Component } from 'react'
import BrowserDetection from 'react-browser-detection';

import MainComponent from './components/MainComponent'
import './assets/Global.scss'
import './App.scss'



class App extends Component {    
  
  componentDidMount() {
    // vars
    var scrollOneSpeed = 0.1
    var scrollTwoSpeed = 0.2
    var scrollThreeSpeed = 0.01

    // transform vertical scroll to horizontal scroll
    function transformScroll(event) {
      event.preventDefault();
      if (event.deltaMode === 1) {
        event.currentTarget.scrollLeft += event.deltaY * 10;
      } else {
          event.currentTarget.scrollLeft += event.deltaY;
          parallax()          
      }
    }

    var element = document.querySelector('.viewer');
    element && element.addEventListener('wheel', transformScroll)
    element && element.addEventListener('scroll',parallax)
    // element.addEventListener('touchmove', parallax)

    //horizopntal parallax scrolling  
    function parallax() {
        var scrolled =  document.querySelector('.viewer').scrollLeft
        var scrollOne = document.querySelectorAll('.scroll-one');
        if(scrollOne) {
          for(var i1=0;i1<scrollOne.length;i1++) {
            var offset1 = getParentWidth(scrollOne[i1],'.chapter')
            scrollOne[i1].style.left = -((scrolled - offset1) * scrollOneSpeed) + 'px';
          }
      }

      var scrollTwo = document.querySelectorAll('.scroll-two');
      if(scrollTwo) {
        for(var i2=0;i2<scrollTwo.length;i2++) {
            var offset2 = getParentWidth(scrollTwo[i2],'.chapter')
            scrollTwo[i2].style.left = -((scrolled - offset2) * scrollTwoSpeed) + 'px';
        }
      }

      var scrollThree = document.querySelectorAll('.scroll-three');
      if(scrollThree) {
        for(var i3=0;i3<scrollThree.length;i3++) {
          var offset3 = getParentWidth(scrollThree[i3],'.chapter')
            scrollThree[i3].style.left = -((scrolled - offset3) * scrollThreeSpeed) + 'px';
        }
      }

      function getParentWidth(el, sel) {
        
        while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
        if(!el.classList.contains('intro')) {
          var width = el.offsetWidth
          return width
        } else {
          return 0
        }
      }
    }
  }

  render() {
    const browserHandler = {
      ie: (browser) => <div className='ie'><h1>Hei. Du benytter en eldre nettleser ({browser}) som denne nettsiden ikke fungerer så godt i. Vi anbefaler at du heller forsøker å åpne nettsoiden i Chrome, FireFox, Edge eller Safari.</h1></div>,
      default: () => <MainComponent />,
    }
    return (
      <>
        <BrowserDetection>
          {browserHandler}
        </BrowserDetection>
        {/* <div id="debugger" style={
          {
          position: 'fixed',
          bottom: 0,left: 0,
          background: 'white',
          zIndex: 1001,
          }
          }></div> */}
      </>
    )
  }
}

export default App;
